import { Box, Typography, Card, Link, Stack } from '@mui/joy'
import Button from '@mui/joy/Button'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import ChatApisPreview from 'components/ChatApisPreview/ChatApisPreview'
import { useQueryClient } from 'react-query'
import { useAuth } from 'context/Auth'
import { useIntegrationList } from 'api/chat-api-integration'
import { Link as RouterLink } from 'react-router-dom'
import PlaygroundIntegration from 'components/Playground/PlaygroundIntegration'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { useState } from 'react'

type Props = {}

const PlaygroundsPage = (props: Props) => {
    const { user } = useAuth()

    if (!user?.access) {
        throw new Error('User has no access and cannot fetch messages.')
    }

    const workspaceId = user?.access?.workspaceId
    const userId = user?.access?.internalUserId

    const [from, setFrom] = useState(
        dayjs().add(-92, 'days').startOf('day').unix()
    )
    const [to, setTo] = useState(dayjs().endOf('day').unix())

    const [dateFormat, setDateFormat] = useState('MMM DD, YYYY')

    const {
        data: integrationList,
        isLoading,
        isError,
    } = useIntegrationList({
        workspaceId: workspaceId,
        userId: userId,
        limit: 25,
        page: 1,
    })

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    my: 1,
                    gap: 1,
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'start', sm: 'center' },
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                }}
            >
                <Typography level="h2">Playground</Typography>
                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        marginTop: '12px',
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            closeOnSelect={true}
                            label="From"
                            value={dayjs.unix(
                                from ?? dayjs().startOf('day').unix()
                            )}
                            format={dateFormat}
                            onChange={(newValue) => {
                                setFrom(newValue?.unix() ?? dayjs().unix())

                                return
                            }}
                        />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="To"
                            closeOnSelect={true}
                            value={dayjs.unix(
                                to ?? dayjs().startOf('day').unix()
                            )}
                            format={dateFormat}
                            onChange={(newValue) => {
                                setTo(newValue?.unix() ?? dayjs().unix())

                                return
                            }}
                        />
                    </LocalizationProvider>
                </Stack>
            </Box>
            <Box>
                {integrationList?.length ? (
                    <PlaygroundIntegration from={from} to={to} />
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            flexDirection: 'column',
                            height: '100%',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Box
                            maxWidth={540}
                            sx={{
                                textAlign: 'center',
                            }}
                        >
                            <Typography level={'h3'}>
                                To test the Pavuk AI Chat API in the Playground,
                                you first need to create an Integration on the{' '}
                                <Link component={RouterLink} to="/integrations">
                                    Messengers
                                </Link>{' '}
                                page.
                            </Typography>
                        </Box>
                    </Box>
                )}
            </Box>
        </>
    )
}

export default PlaygroundsPage
